// extracted by mini-css-extract-plugin
export var redoItem = "_kg-1";
export var redoTrigger = "_kg-0";